// extracted by mini-css-extract-plugin
export default {"maxHeight":"dialog_maxHeight__OZ6AB"};